<div class="relative">
  <t-button
    (click)="dialPhoneNumber()"
    [disabled]="callingDisabled || !phoneNumber"
    variant="primary"
    size="tiny"
    icon="call" />
</div>
